export const stateZipCodes = {
    'Alabama': '36104',
    'Arizona': '85001',
    'Arkansas': '72201',
    'California': '95814',
    'Colorado': '80202',
    'Connecticut': '06103',
    'Delaware': '19901',
    'Florida': '32301',
    'Georgia': '30303',
    'Hawaii': '96813',
    'Idaho': '83702',
    'Illinois': '62701',
    'Indiana': '46204',
    'Iowa': '50309',
    'Kansas': '66603',
    'Kentucky': '40601',
    'Louisiana': '70802',
    'Maine': '04330',
    'Maryland': '21401',
    'Massachusetts': '02108',
    'Michigan': '48933',
    'Minnesota': '55102',
    'Mississippi': '39205',
    'Missouri': '65101',
    'Montana': '59601',
    'Nebraska': '68508',
    'Nevada': '89701',
    'New Hampshire': '03301',
    'New Jersey': '08608',
    'New Mexico': '87501',
    'New York': '12207',
    'North Carolina': '27601',
    'North Dakota': '58501',
    'Ohio': '43215',
    'Oklahoma': '73102',
    'Oregon': '97301',
    'Pennsylvania': '17101',
    'Rhode Island': '02903',
    'South Carolina': '29217',
    'South Dakota': '57501',
    'Tennessee': '37219',
    'Texas': '78701',
    'Utah': '84111',
    'Vermont': '05602',
    'Virginia': '23219',
    'Washington': '98501',
    'West Virginia': '25301',
    'Wisconsin': '53703',
    'Wyoming': '82001'
};